export default __webpack_public_path__ + "static/img/26.34b4d4d.png";